export enum WidgetTypes {
  BannerWidget = 'inspired-announcement-banner',
  FloatingWidget = 'inspired-floating-widget',
  EmbeddedWidget = 'inspired-impact-offer',
  CartProgressWidget = 'inspired-cart-progress-widget'
}

export enum WidgetPositions {
  Before = 'before',
  After = 'after',
  InsideTop = 'insideTop',
  InsideBottom = 'insideBottom'
}

export enum Platforms {
  Shopify = 1,
  ShopifyHeadless = 2,
  BigCommerce = 3
}

export enum GlobalEvents {
  ToggleModal = 'TOGGLE_GLOBAL_MODAL',
  SelectCause = 'SELECT_CAUSE'
}

export enum WidgetLocations {
  CartPage = 'cartPage',
  CartDrawer = 'cartDrawer',
  ProductPage = 'productPage',
  HomePage = 'homePage',
  CollectionsPage = 'collectionsPage',
  Global = 'global',
  Unknown = 'unknown'
}

export enum MixpanelWidgetLocations {
  CartPage = 'cart-page',
  CartDrawer = 'cart-drawer',
  ProductPage = 'product-page',
  HomePage = 'home-page',
  CollectionsPage = 'collections-page',
  BlogListingPage = 'blog-listing-page',
  BlogArticlePage = 'blog-article-page',
  ContactPage = 'contact-page',
  CustomPage = 'custom-page',
  Unknown = 'unknown'
}

export enum WidgetVisibility {
  Global = 'global',
  Home = 'home',
  Product = 'product',
  Cart = 'cart',
  Collections = 'collections',
}

export enum Style {
  Custom = 'custom',
  Default = 'default'
}

export enum PreviewTypes {
  EmbeddedCartDrawer = 'embeddedCartDrawer',
  ProgressCartDrawer = 'progressCartDrawer',
  Banner = 'banner',
  Floating = 'floating'
}

